<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Select Property'"
    [canGoBack]="true" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  @if (windowService.isDesktopRes) {
    <tidy-loading-bar class="js-tidy-loading" />
  }
  <tidy-wrapper>

    <tidy-row>
      <form [formGroup]="form">
        <tidy-select
          [icon]="'assets/svg/home.svg'"
          [label]="'Select property'"
          [items]="propertyItems"
          [form]="form.controls.property"
          formControlName="property" />
      </form>
    </tidy-row>

    <tidy-button
      [text]="'Next'"
      [action]="boundGoToNextPage"
      class="primary" />

  </tidy-wrapper>
</ng-template>

@if (!windowService.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
